import { SHOW_TOOLTIP, HIDE_TOOLTIP } from './constants';

const initialState = {
    show: false,
    showOnClick: false,
    position: null,
    childComponent: null,
    target: null,
    delayTime: null,
    hideOnDocClick: false,
    isUpdatableWidth: false
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SHOW_TOOLTIP:
            return Object.assign(
                {},
                {
                    show: true
                },
                action.payload
            );

        case HIDE_TOOLTIP:
            return initialState;

        default:
            return state;
    }
}